// extracted by mini-css-extract-plugin
export default {"sellerCard":"styles_sellerCard__IEUvX","sellerInfo":"styles_sellerInfo__PfdPX","avatar":"styles_avatar__4Mwv8","sellerStatsDesc":"styles_sellerStatsDesc__DcT1Q"};